import { useEffect, useState } from "react";
import useHttp from "components/hooks/useHttp";
import useToast from "components/hooks/useToast";

export type PageType = "custom" | "custom_success" | "auth" | "auth_success";

export enum BlockType {
    IMAGE = "image",
    STATIC = "static",
    BUTTON = "button",
    DIVIDER = "divider",
    SPACING = "spacing",
    QR_CODE = "qr_code",
    CUSTOM_FIELD = "custom_field",
    SUBMIT_BUTTON = "submit_button",
    ADD_TO_WALLET = "add_to_wallet",
    CONTACT_ATTRIBUTE = "contact_attribute",
    SUBSCRIPTION_TYPE = "subscription_type",
}

export type FormBlockType = {
    uuid: string;
    name: string;
    type: BlockType,
    data: Record<string, any>
}

export type Page = {
    id: number;
    name: string;
    type: PageType;
    blocks: FormBlockType[],
};

export enum FormType {
    PUBLIC = "public",
    PRIVATE = "private",
}

export type Branding = {
    font_family: string;
    font_uuid: string;
    font_type: "custom" | "google";
    style: string,
    width: number,
    font_url: string,
    text_color: string,
    background_color: string,
    button_text_color: string,
    card_background_color: string,
    button_background_color: string,
    font: {
        type: FontType,
        family: string,
        url: string,
    },
}

export type FontType = "custom" | "google";

export type Form = {
    icon: string;
    type: FormType;
    name: string;
    uuid: string;
    pages: Page[];
    is_active: boolean;
    prepopulates: boolean;
    branding: Branding,
    default_values: Record<string, any>
};

export default function useFetchForm(formUuid: string) {
    const http = useHttp();
    const { errorToast } = useToast();
    const [formPending, setFormPending] = useState(false);
    const [form, setForm] = useState<Form>(null);
    const apiUrl = `/forms/${formUuid}`;

    useEffect(() => {
        setFormPending(true);
        http.get(apiUrl)
            .then(res => setForm(res.data.data))
            .catch(errorToast)
            .finally(() => setFormPending(false));
    }, []);

    return {
        form,
        formPending,
    };
}